import React, { Component, Fragment } from "react";
import { Form } from "react-bootstrap";
import { Dropdown } from "semantic-ui-react";
import AlertBasic from "../alerts/AlertBasic";
import $ from "jquery";

class EvaluationResults extends Component {
    state = {
        evaluationResultsList: [],
        value: this.props.defaultValue ? this.props.defaultValue : null,
    };

    getEvaluationResults = async () => {
        const { fetchURL, defaultValue } = this.props;
        try {
            const response = await fetch(`${fetchURL}/evaluation-results`, {
                credentials: "include", //include - bez tego nie będą pojawiać się ciasteczka w przeglądarce
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
            });
            if (response.status === 200) {
                await response.json().then((fetchedData) => {
                    //console.log(fetchedData);
                    if (fetchedData.status === true) {
                        let evaluationResultsList = fetchedData.evaluationResultsList;
                        if (defaultValue === "all") {
                            evaluationResultsList.unshift({
                                key: 0,
                                value: "all",
                                text: "Wszystkie",
                            });
                            evaluationResultsList.push({
                                key: evaluationResultsList.length + 1,
                                value: "NONE",
                                text: "Brak oceny",
                            });
                        }

                        evaluationResultsList[0].selected = false;

                        this.setState({ evaluationResultsList: evaluationResultsList });
                    } else if (fetchedData.status === false) {
                        this.setState({ alert: { variant: "danger", message: fetchedData.message } });
                    }
                });
            } else {
                this.setState({ alert: { variant: "danger", message: response.status } });
            }
        } catch (err) {
            this.setState({ loading: false, alert: { variant: "danger", message: "Błąd połączenia z serwerem. Spróbuję pobrać/wysłać dane jeszcze raz." } });
            setTimeout(this.getEvaluationResults(), 4000);
        }
    };

    componentDidUpdate() {
        if (this.props.defaultValue !== this.state.value) this.setState({ value: this.props.defaultValue });
    }

    componentDidMount() {
        this.getEvaluationResults();
    }

    render() {
        const { evaluationResultsList, alert, value } = this.state;
        const { onEvaluationResultSelected, labelTxt, req } = this.props;
        return (
            <Fragment>
                {alert && <AlertBasic variant={alert.variant} mssg={alert.message} onCloseAlert={() => this.setState({ alert: "" })} fading={alert.fading} />}

                <Form.Group>
                    <Form.Label>
                        {labelTxt} {req && <span className="required">*</span>}
                    </Form.Label>

                    <Dropdown
                        id="questionEvalResultsDropdown"
                        className="mb-3"
                        placeholder="Kliknij, aby wybrać kwalifikację"
                        fluid
                        value={value}
                        selection
                        options={evaluationResultsList}
                        onChange={(event, { value }) => {
                            $("#questionEvalResultsDropdown").removeClass("is-invalid");
                            onEvaluationResultSelected(event, value);
                            this.setState({ value: value });
                        }}
                    />
                </Form.Group>
            </Fragment>
        );
    }
}

export default EvaluationResults;
